export default {
    parts: ['loadingStateContainer', 'contentContainer', 'overlaySpinnerContainer', 'iframe'],
    baseStyle: {
        loadingStateContainer: {
            maxW: '1400px',
            mx: 'auto',
            px: 4,
            minH: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        contentContainer: {
            maxW: '1400px',
            mx: 'auto',
            px: 4,
            position: 'relative',
            minH: '90vh'
        },
        overlaySpinnerContainer: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minH: '40vh'
        },
        iframe: {
            width: '100%',
            height: '90vh',
            border: 0,
            display: 'block'
        }
    }
}
